import { Formik, Form, FieldArray, Field } from "formik";
import Input from "../_local/components/Input/index";
import ImageUpload from "../_local/components/ImageUpload/index";
import TextArea from "../_local/components/TextArea/index";
import ResetAndSubmit from "../_local/components/ResetAndSubmit/index";
import * as Yup from 'yup';
import { getImageValidationSchema } from "../_local/constants/validationSchemas/index";
import FormWrapper from "../_local/components/FormWrapper/index";
import Card from "../_local/components/OnboardingFormCard/index";
import Dropdown from "../_local/components/Dropdown/index";
import { generateUniqueId } from "../_local/utils/index";

const Founders = ({ handleNavigate, resetFormData, disableForm }: { handleNavigate, resetFormData?: any, titleAndDesNotRequired?: boolean, disableForm?: boolean }) => {

    const createEmptyFoundersData = () => ({
        ID: generateUniqueId(),
        DRAWER: false,
        INSTITUTE_LEADER_IMAGE: "",
        INSTITUTE_LEADER_NAME: "",
        GENDER: "",
        INSTITUTE_LEADER_EMAIL: "",
        COUNTRY_CODE: "+91",
        INSTITUTE_LEADER_MOBILE: "",
        INSTITUTE_LEADER_DESIGNATION: "",
        INSTITUTE_LEADER_QUALIFICATION: "",
        INSTITUTE_LEADER_EXPERIENCE: "",
        INSTITUTE_LEADER_DESCRIPTION: "",
    });

    const instituteSavedData = JSON.parse(sessionStorage.getItem("Institute")) || {};

    const loadInitialData = () => {
        const savedData = JSON.parse(sessionStorage.getItem("founders")) || [];

        return ["Founder", "Principal", "Vice Principal", "School Administrator"]
            .map((item) => (savedData?.find(f => f.INSTITUTE_LEADER_DESIGNATION === item)) || ({ ...createEmptyFoundersData(), INSTITUTE_LEADER_DESIGNATION: item }))

        // Remove empty entries before initializing the form
        // return savedData.length
        //     ? savedData.filter(f => f.INSTITUTE_LEADER_NAME?.trim())
        //     : ["Founder", "Principal", "Vice Principal", "School Administrator"]
        //         .map(item => ({ ...emptyLeaderData, INSTITUTE_LEADER_DESIGNATION: item }));
    };

    const validationSchema = Yup.object({
        founders: Yup.array().of(
            Yup.object({
                INSTITUTE_LEADER_NAME: Yup.string().trim().nullable(),

                INSTITUTE_LEADER_IMAGE: Yup.mixed().when("INSTITUTE_LEADER_NAME", (name: any, schema) =>
                    !!name?.[0] ? getImageValidationSchema("Institute leader's image is required") : schema
                ),

                COUNTRY_CODE: Yup.string().when("INSTITUTE_LEADER_NAME", (name: any, schema) =>
                    !!name?.[0] ? schema.required("Country code is required") : schema
                ),

                INSTITUTE_LEADER_EMAIL: Yup.string().when("INSTITUTE_LEADER_NAME", (name: any, schema) =>
                    !!name?.[0] ? schema.required("Email is required") : schema
                ),

                GENDER: Yup.string().when("INSTITUTE_LEADER_NAME", (name: any, schema) =>
                    !!name?.[0] ? schema.required("Gender is required") : schema
                ),

                INSTITUTE_LEADER_MOBILE: Yup.string()
                    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
                    .when("INSTITUTE_LEADER_NAME", (name: any, schema) =>
                        !!name?.[0] ? schema.required("Mobile number is required") : schema
                    ),

                INSTITUTE_LEADER_DESIGNATION: Yup.string().when("INSTITUTE_LEADER_NAME", (name: any, schema) =>
                    !!name?.[0] ? schema.required("Leader's designation is required") : schema
                ),

                INSTITUTE_LEADER_QUALIFICATION: Yup.string().when("INSTITUTE_LEADER_NAME", (name: any, schema) =>
                    !!name?.[0] ? schema.required("Leader's qualification is required") : schema
                ),

                INSTITUTE_LEADER_EXPERIENCE: Yup.number().when("INSTITUTE_LEADER_NAME", (name: any, schema) =>
                    !!name?.[0] ? schema.required("Leader's experience is required") : schema
                ),
            })
        ),
    });



    return <Formik
        initialValues={{ founders: loadInitialData() }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => {
            // Filter out empty founders (without a name)
            const filteredFounders = values.founders.filter(f => f.INSTITUTE_LEADER_NAME?.trim());

            // Save only non-empty founders
            sessionStorage.setItem("founders", JSON.stringify(filteredFounders));

            handleNavigate();
        }}

    >
        {({ values, handleSubmit, resetForm, errors }) =>
            <FormWrapper
                title={"Founders/Leaders - The visionaries who shape the future of our country."}
                description={"Upload Chairman, Principal, and Vice Principal photos who  guides students to become successful citizens."}
                childern={<Form onSubmit={handleSubmit}>
                    <div>
                        <div className="rounded-2xl my-1 mx-1">
                            <FieldArray name="founders">
                                {({ push, remove, form }) => (
                                    <div className="grid grid-cols-4 gap-4 sm:grid-cols-1 md:grid-cols-1">
                                        {values.founders.map((leaderElement, index) => (
                                            <Card
                                                key={leaderElement?.ID}
                                                isError={Boolean(errors?.founders?.[index])}
                                                index={index}
                                                handleOpenDrawer={() => form.setFieldValue(`founders.${index}.DRAWER`, true)}
                                                handleCloseDrawer={() => form.setFieldValue(`founders.${index}.DRAWER`, false)}
                                                onDelete={() => form.setFieldValue(`founders[${index}]`, { ...createEmptyFoundersData(), INSTITUTE_LEADER_DESIGNATION: leaderElement?.INSTITUTE_LEADER_DESIGNATION })}
                                                element={leaderElement}
                                                children={<div className="flex flex-wrap gap-x-2 gap-y-4">
                                                    <div className="w-[48%]">
                                                        <Input
                                                            disable={disableForm}
                                                            label="Name of the founder/leader"
                                                            name={`founders.${index}.INSTITUTE_LEADER_NAME`}
                                                            type="text"
                                                            placeHolder="Enter their name here"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="w-[48%]">
                                                        <Input
                                                            disable={disableForm}
                                                            label="Qualification"
                                                            name={`founders.${index}.INSTITUTE_LEADER_QUALIFICATION`}
                                                            type="text"
                                                            placeHolder="Enter Qualification"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="w-[48%]">
                                                        <Input
                                                            disable={disableForm}
                                                            label="Years of Experience"
                                                            name={`founders.${index}.INSTITUTE_LEADER_EXPERIENCE`}
                                                            type="number"
                                                            placeHolder="Enter years of experience"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="w-[48%]">
                                                        <Dropdown
                                                            disable={disableForm}
                                                            name={`founders.${index}.GENDER`}
                                                            label="Gender"
                                                            placeHolder="Select Gender"
                                                            required
                                                            options={[{ value: "MALE", label: "MALE" }, { value: "FEMALE", label: "FEMALE" }, { value: "OTHER", label: "OTHER" }]}
                                                        />
                                                    </div>
                                                    <div className="w-[48%]">
                                                        <Input
                                                            disable={disableForm}
                                                            label="Mobile Number"
                                                            name={`founders.${index}.INSTITUTE_LEADER_MOBILE`}
                                                            type="text"
                                                            placeHolder="Enter Mobile"
                                                            isMobile
                                                            countryCodeName={`founders.${index}.COUNTRY_CODE`}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="w-[48%]">
                                                        <Input
                                                            disable={disableForm}
                                                            label="Email Address"
                                                            name={`founders.${index}.INSTITUTE_LEADER_EMAIL`}
                                                            type="email"
                                                            placeHolder="Enter email"
                                                            required
                                                        />
                                                    </div>
                                                    {<div className="w-full">
                                                        <TextArea
                                                            disabled={disableForm || !(!!leaderElement?.INSTITUTE_LEADER_NAME && !!leaderElement?.INSTITUTE_LEADER_QUALIFICATION && !!leaderElement?.INSTITUTE_LEADER_EXPERIENCE && !!leaderElement?.INSTITUTE_LEADER_DESIGNATION)}
                                                            label="Description"
                                                            name={`founders.${index}.INSTITUTE_LEADER_DESCRIPTION`}
                                                            generate={{
                                                                "category": "leaders",
                                                                "kwargs": {
                                                                    "name": leaderElement?.INSTITUTE_LEADER_NAME,
                                                                    "org_type": instituteSavedData?.INSTITUTE_TYPE,
                                                                    "org_name": instituteSavedData?.NAME,
                                                                    "qualification": leaderElement?.INSTITUTE_LEADER_QUALIFICATION,
                                                                    "experience": leaderElement?.INSTITUTE_LEADER_EXPERIENCE,
                                                                    "designation": leaderElement?.INSTITUTE_LEADER_DESIGNATION,
                                                                }
                                                            }}
                                                            autoGenerate={true}
                                                        />
                                                    </div>}
                                                    <div className="w-full">
                                                        <Field name={`founders.${index}.INSTITUTE_LEADER_IMAGE`}>
                                                            {({ field, form, meta }) => (
                                                                <ImageUpload
                                                                    // isError={!!(errors?.founders?.[index] as any)?.INSTITUTE_LEADER_IMAGE}
                                                                    isError={!!meta.touched && !!meta.error}
                                                                    disable={disableForm}
                                                                    label="Upload Profile picture"
                                                                    // wantHDOption
                                                                    maxSize={5}
                                                                    labelClassNames="text-[2vh]"
                                                                    containerHeight={{
                                                                        width: "7vh",
                                                                        height: "7vh",
                                                                    }}
                                                                    imageValue={field.value}
                                                                    onChange={(item) => {
                                                                        form.setFieldValue(`founders.${index}.INSTITUTE_LEADER_IMAGE`, item);
                                                                    }}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>
                                                </div>}
                                            />
                                        ))}
                                    </div>
                                )}
                            </FieldArray>
                        </div>
                    </div>
                    {!disableForm && <ResetAndSubmit
                        submitToolTip={!Boolean(values?.founders?.filter(item => !!item?.INSTITUTE_LEADER_NAME)?.length) ? "At least one data entry is required for the next step." : Boolean(errors?.founders) ? "Please fill in all the required fields." : ""}
                        isError={!Boolean(values?.founders?.filter(item => !!item?.INSTITUTE_LEADER_NAME)?.length) || Boolean(errors?.founders)}
                        resetForm={() => {
                            resetForm();
                            resetFormData();
                        }}
                    />}
                </Form>}
            />}
    </Formik>
};

export default Founders;